import React, { useState, useEffect, use } from "react";
import TableCellRegressionDiff from "../table/TableCellRegressionDiff";
import Utils from "../../utils/Utils";
import Image from "next/image";
import TableCellRank from "../table/TableCellRank";
import TableSkeleton from "../table/TableSkeleton";
import Link from "next/link";
import { MatchupHomeAwaySelect } from "./Constants";
const tableHeader = [
  {
    title: "ShotType Stats",
    showImage: false,
    sortable: false,
    key: "ShotTypeStats",
  },
];

export const ShotTypeStats = ({
  teamName,
  opponentName,
  revertDefense,
  teamShottypes,
  user,
  league,
  conferenceTeamCount = 0,
}) => {
  const [dataLoaded, setDataLoaded] = useState(null);
  const [isConferenceOnly, setIsConferenceOnly] = useState(false);
  const [dataToShow, setDataToShow] = useState(null);
  const [homeAwayFilter, setHomeAwayFilter] = useState({ value: "Default", label: "Default" });

  const rankConfig = {
    leagueType: league,
  };
  useEffect(() => {
    if (teamShottypes?.opponentName?.data?.length && teamShottypes?.teamName?.data?.length) {
      setDataLoaded(true);
    }
    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
  }, [teamShottypes]);

  useEffect(() => {
    if (teamShottypes?.opponentName?.data?.length && teamShottypes?.teamName?.data?.length) {
      // When Conference Only and Home are checked, pull home_conf_data
      // When Conference Only and Away are checked, pull away_conf_data
      // When justHome is checked, pull home_data
      // When just Away is checked, pull away_data
      // When just Conference Only is checked, pull conf_data
      // When nothing is checked, pull data
      if (homeAwayFilter.value === "Home" && isConferenceOnly) {
        setDataToShow({
          team: teamShottypes?.teamName?.home_conf_data,
          opponent: teamShottypes?.opponentName?.home_conf_data,
        });
      } else if (homeAwayFilter.value === "Away" && isConferenceOnly) {
        setDataToShow({
          team: teamShottypes?.teamName?.away_conf_data,
          opponent: teamShottypes?.opponentName?.away_conf_data,
        });
      } else if (homeAwayFilter.value === "Home") {
        setDataToShow({ team: teamShottypes?.teamName?.home_data, opponent: teamShottypes?.opponentName?.home_data });
      } else if (homeAwayFilter.value === "Away") {
        setDataToShow({ team: teamShottypes?.teamName?.away_data, opponent: teamShottypes?.opponentName?.away_data });
      } else if (isConferenceOnly) {
        setDataToShow({ team: teamShottypes?.teamName?.conf_data, opponent: teamShottypes?.opponentName?.conf_data });
      } else {
        setDataToShow({ team: teamShottypes?.teamName?.data, opponent: teamShottypes?.opponentName?.data });
      }
    }
  }, [isConferenceOnly, teamShottypes, revertDefense, homeAwayFilter]);

  const handleCheckboxClick = (e) => {
    isConferenceOnly ? setIsConferenceOnly("") : setIsConferenceOnly(e);
  };

  return (
    <>
      {!dataLoaded ? (
        <TableSkeleton
          tableHeader={tableHeader}
          tableRowsCount={10}
          className="table-space matchup-output-lazyloading"
          tableHeaderHeight="90px"
        ></TableSkeleton>
      ) : null}
      {dataLoaded ? (
        <table className="table tl-fixed-desktop shotTypeStats">
          <thead>
            <tr className="text-center">
              {/* <th colSpan={2} style={{ verticalAlign: "initial" }}>
                ShotType Stats
              </th> */}
              <th colSpan={5} className="text-right">
                <div className="d-flex justify-content-between">
                  <span className="mr-2 text-left" style={{ fontSize: "1.2rem" }}>
                    ShotType Stats
                  </span>
                  <div className="d-inline-flex align-items-center">
                    <input
                      type="checkbox"
                      id={`shotTypeConferenceOnlyCheck_${revertDefense ? opponentName : teamName}`}
                      onClick={() => {
                        handleCheckboxClick(teamName);
                      }}
                    />
                    <label
                      className="mb-0 ml-2 mr-2"
                      style={{ whiteSpace: "pre", fontSize: "1rem", fontWeight: 600 }}
                      htmlFor={`shotTypeConferenceOnlyCheck_${revertDefense ? opponentName : teamName}`}
                    >
                      Conference only
                    </label>
                    <MatchupHomeAwaySelect homeAwayFilter={homeAwayFilter} setHomeAwayFilter={setHomeAwayFilter} />
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={2} style={{ padding: "12px" }} className="align-items-center">
                <div className="d-flex table-header-wrap">
                  <div className="teamLogoMiniWrapper">
                    <Image
                      height={24}
                      width={24}
                      alt="team logo"
                      style={{ marginRight: "8px" }}
                      src={`http://shotqualitybets.com/static/media/logos/${
                        revertDefense ? opponentName : teamName
                      }.png`}
                    />
                    <span style={{ fontSize: "14px", fontWeight: 600 }}>Offensive</span>
                  </div>
                </div>
              </td>
              <td />
              <td />
              <td className="d-flex align-items-center justify-content-end table-header-wrap">
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Defensive
                </span>
                <div
                  className="teamLogoMiniWrapper"
                  style={{
                    marginLeft: "8px",
                  }}
                >
                  <Image
                    height={24}
                    width={24}
                    alt="team logo"
                    src={`http://shotqualitybets.com/static/media/logos/${revertDefense ? teamName : opponentName}.png`}
                  />
                </div>
              </td>
            </tr>
            {!user?.has_paid ? (
              <tr>
                <td className="text-center" colSpan={5} style={{ background: "white" }}>
                  <span style={{ fontSize: "14px" }} className="text-center p-2">
                    🔒 <span style={{ color: "#f26b0b" }}>{revertDefense ? opponentName : teamName} </span>
                    Regression Stats are available to existing ShotQualityBets members.
                  </span>
                </td>
              </tr>
            ) : (
              <tr className="descriptionRow">
                <td>SQ PPP</td>
                <td>Freq %</td>
                <td />
                <td>SQ PPP</td>
                <td>Freq %</td>
              </tr>
            )}

            {user?.has_paid ? (
              <>
                {dataToShow &&
                  dataToShow.team.map((shotType, i) => {
                    if (!shotType["Offensive SQ PPP rank"]) {
                      return null;
                    }
                    if (league === "wnba" && shotType["Name"] === "Half Court") {
                      return null;
                    }
                    return (
                      <tr className="shotTypeStatsRow" key={`${teamName}_${shotType.Name}`}>
                        <TableCellRank
                          rankValue={
                            revertDefense
                              ? dataToShow.opponent[i]["Offensive SQ PPP rank"]
                              : shotType["Offensive SQ PPP rank"]
                          }
                          {...rankConfig}
                          conferenceTeamCount={isConferenceOnly ? conferenceTeamCount : 0}
                        >
                          <b>
                            {revertDefense
                              ? dataToShow?.opponent[i]["Offensive SQ PPP"]?.toFixed(2)
                              : shotType["Offensive SQ PPP"]?.toFixed(2)}
                          </b>
                        </TableCellRank>
                        <TableCellRank
                          rankValue={
                            revertDefense
                              ? dataToShow?.opponent[i]["Offensive Frequency rank"]
                              : shotType["Offensive Frequency rank"]
                          }
                          hideGradients
                          {...rankConfig}
                          conferenceTeamCount={isConferenceOnly ? conferenceTeamCount : 0}
                        >
                          <b>
                            {revertDefense
                              ? Utils.toPercent(dataToShow?.opponent[i]["Offensive Frequency"])
                              : Utils.toPercent(shotType["Offensive Frequency"])}
                          </b>
                        </TableCellRank>

                        <td className="text-center">{shotType.Name}</td>

                        <TableCellRank
                          rankValue={
                            revertDefense
                              ? shotType["Defensive SQ PPP rank"]
                              : dataToShow?.opponent[i]["Defensive SQ PPP rank"]
                          }
                          {...rankConfig}
                          conferenceTeamCount={isConferenceOnly ? conferenceTeamCount : 0}
                        >
                          <b>
                            {revertDefense
                              ? shotType["Defensive SQ PPP"]?.toFixed(2)
                              : dataToShow?.opponent[i]["Defensive SQ PPP"]?.toFixed(2)}
                          </b>
                        </TableCellRank>
                        <TableCellRank
                          rankValue={
                            revertDefense
                              ? shotType["Defensive Frequency rank"]
                              : dataToShow?.opponent[i]["Defensive Frequency rank"]
                          }
                          hideGradients
                          {...rankConfig}
                          conferenceTeamCount={isConferenceOnly ? conferenceTeamCount : 0}
                        >
                          <b>
                            {revertDefense
                              ? Utils.toPercent(shotType["Defensive Frequency"])
                              : Utils.toPercent(dataToShow?.opponent[i]["Defensive Frequency"])}
                          </b>
                        </TableCellRank>
                      </tr>
                    );
                  })}
              </>
            ) : (
              <></>
            )}
          </tbody>
        </table>
      ) : null}
    </>
  );
};
